import { render, staticRenderFns } from "./ParentStores.vue?vue&type=template&id=c8f63cf0"
import script from "./ParentStores.vue?vue&type=script&lang=js"
export * from "./ParentStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports